import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ws-info-card",
  templateUrl: "./ws-info-card.component.html",
  styleUrls: ["./ws-info-card.component.scss"],
})
export class WsInfoCardComponent implements OnInit {
  @Input() subtitle: string = "";
  @Input() bigValue: string = "";
  @Input() smallValue: string = "";
  @Input() icon: string = "";
  @Input() isMini: boolean = false;
  @Input() tooltip: string = "";
  @Input() forceSize: boolean = true; // Default: force dimensions
  infoVisibility: boolean = false;

  constructor() {}

  ngOnInit() {}
}
